// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d2060960","977":"c34478ad"}[chunkId] + ".chunk.js";
};